<template>
  <v-card color="primary" dark class="mb-6 pa-2 mx-auto" max-width="300" min-height="150" flat>
    <v-card-title v-html="title"></v-card-title>
    <v-card-text v-html="text"></v-card-text>
    <v-card-actions>
      <v-btn color="accent" dark :href="link" block depressed>
        Donate
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'DonateWidget',

    props: {
      title: {
        type: String,
        default: 'Support ConservativeHome'
      },
      text: {
        type: String,
        default: 'Help ensure we can continue to provide engaging events and daily, year-round coverage of politics, current affairs, policy and ideas'
      },
      link: {
        type: String,
        default: '/donate'
      }
    }
  }
</script>

<style lang="sass" scoped>
  .v-card__title
    word-break: initial
    font-size: 1rem
    line-height: 1.5rem
</style>
